// import TicketMenuManagementCreate from "./lib/create";
import TicketsTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
import TicketCounts from './lib/ticketCounts';

export default function AccessManagementActivitiesPage() {
  const { tickets, ticketCategory } = useTypedSelector((state) => state.Tickets);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <S.Head>
        <PageTitle title="Entrance and Exit Times" />
        <TicketCounts />
      </S.Head>
      <Gap size="20px" />
      <TicketsTable
        data={tickets.data}
        departments={departments.data}
        ticketCategory={ticketCategory.data}
        loading={tickets.loading}
      />

      <AppLoading loading={tickets.loading || departments.loading || ticketCategory.loading} />
    </S.Container>
  );
}
